@import (reference) '../../../../../../constants/spacing.module.less';

.error-container {
  background-color: var(--red-200);
  border: 1px solid var(--red-300);
  border-radius: 4px;
  padding: @space-12;
  margin-bottom: @space-16;
}

.error-message {
  color: var(--red-600);
  font-size: 14px;
  margin-bottom: @space-4;

  &:last-child {
    margin-bottom: 0;
  }
}

.package-dropdown {
  width: 100%;

  button {
    font-weight: 400;
  }

  .dropdown-button-text {
    font-weight: 400;
  }

  .dropdown-button {
    font-weight: 400;
  }

  .package-dropdown-button {
    font-weight: 400;
  }
}

.return-url {
  flex: 1;
  padding: @space-8 @space-12;
  background-color: var(--gray-F9FAFB);
  border: 1px solid var(--gray-DFE4E8);
  border-radius: 4px;
  font-family: monospace;
  font-size: 14px;
  color: var(--gray-637381);
  word-break: break-all;
  min-height: 32px;
}

.copy-button {
  min-width: 32px;
  height: 32px;
  padding: @space-8;
  display: flex;
  align-items: center;
  justify-content: center;
}

.branded-returns-modal {
  padding: @space-16;
}

.exception-text {
  font-size: 14px;
  align-items: center;
  gap: @space-8;
}

.section-seperator {
  margin: @space-24 @space-0;
  border-bottom: 1px solid var(--gray-DFE4E8);
}

.loading-indicator {
  height: 32px;
  width: 32px;
}

.service-dropdown {
  margin-top: @space-16;
}

.url-tool {
  align-items: center;
  margin-top: 8px;
  > label {
    margin-right: @space-8;
  }
}
